import { Alert, Stack, Typography } from '@mui/joy';
import { WarningCircle } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { Color, Level, Size, Variant } from 'theme/enums';

const ICON_SIZE = 24;

interface IProps {
  message: string;
  onRetry: () => void;
}

/**
 * Mirrors VendorQuoteLog's ReportError. Load failures on this page must never fall
 * through to an empty state: "no environments are configured" and "no jobs are
 * running" are claims, and asserting either because a request failed is worse than
 * saying nothing — someone is about to restart an environment on the strength of it.
 */
export const ConsumerLoadError = ({ message, onRetry }: IProps) => {
  const { t } = useTranslation();

  return (
    <Alert
      color={Color.DANGER}
      endDecorator={
        <Button
          color={Color.DANGER}
          onClick={onRetry}
          size={Size.SM}
          text={t('buttonLabelRetry')}
          variant={Variant.OUTLINED}
        />
      }
      size={Size.LG}
      startDecorator={<WarningCircle size={ICON_SIZE} />}
      sx={{ alignItems: 'center', width: '100%' }}
      variant={Variant.SOFT}
    >
      <Stack>
        <Typography level={Level.TITLE_SM}>{t('errorTitleConsumerDataLoad')}</Typography>

        <Typography level={Level.BODY_SM}>{message}</Typography>
      </Stack>
    </Alert>
  );
};
